import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import MostRecentQuoteContainer from "~/Containers/MostRecentQuoteContainer";
import QuoteBox from "~/Components/Global/QuoteBox";
import { useUser } from "@dreamchimney/user-context";
import CommentsContainer from "~/Containers/CommentsContainer";

const HomePage = (props) => {
  const { state: userState } = useUser();

  if (!userState.loaded) {
    return null;
  }
  const isChim = userState && userState.loggedin && userState.isChim;

  let dateToday = new Date();
  const todaysDate = dateToday.toISOString().split("T")[0];

  return (
    <div className="home-page-component">
      <Helmet>
        <title>Quote of the Day | Dream Chimney</title>
      </Helmet>

      <MostRecentQuoteContainer
        render={({ loading, quote }) => {
          const { dateId } = quote;
          if (loading) return <div style={{ textAlign: "center", color: "white" }}> Loading ... </div>;
          return (
            <React.Fragment>
              <QuoteBox quote={quote} />

              <div className="go-previous">
                {isChim && todaysDate !== dateId && (
                  <span>
                    <Link to={`add`}>Add a Quote</Link>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                  </span>
                )}

                <Link to={`previous`}>Previous Quotes</Link>
              </div>

              <div>
                <div className="comments col-md-12">
                  <div className="comments-header">Comments</div>

                  <div className="comments-section">{quote && <CommentsContainer quote={quote} render={(items) => items} />}</div>
                </div>
              </div>
            </React.Fragment>
          );
        }}
      />
    </div>
  );
};

export default HomePage;
